module.exports = __webpack_public_path__ + "static/css/AppVersionMessage.bfa7b545.css";